var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CDataTable',{attrs:{"loading":_vm.isLoading,"items":_vm.items,"fields":_vm.fields,"noItemsView":{
    noResults: _vm.$t('admin.no_results'),
    noItems: _vm.$t('admin.no_items')
  },"border":"","striped":"","hover":"","pagination":""},scopedSlots:_vm._u([{key:"show_user",fn:function({item}){return [_c('td',{staticClass:"py-2"},[_vm._v(" "+_vm._s(item.user.full_name)+" ")])]}},{key:"show_address",fn:function({item}){return [_c('td',{staticClass:"py-2"},[_vm._v(" "+_vm._s(item.address.short)+" ")])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }